<template>
    <div :class="['watchlist-infobox', {'right': rightAlign }]">
        <div class="watchlist-infobox__statuses">
          <p v-if="selectedWatchList.mode !== null && !selectedWatchList.isReadonly" class="watchlist-infobox__status">
              <span class="icon-share2 watchlist-infobox__status-blue-theme"></span>
              <span v-html="$t('Watchlist.infobox.shared')"></span>
          </p>
          <p v-if="selectedWatchList.isReadonly" class="watchlist-infobox__status">
              <span class="icon-user watchlist-infobox__status-red-theme" style="background: transparent;"></span>
              <span v-html="$t('Watchlist.infobox.readonly')"></span>
          </p>
          <p v-if="selectedWatchList.mode === null && !selectedWatchList.isReadonly" class="watchlist-infobox__status">
              <span class="icon-book watchlist-infobox__status-black-theme"></span>
              <span v-html="$t('Watchlist.infobox.normal')"></span>
          </p>
          <p v-if="selectedWatchList.isHidden" class="watchlist-infobox__status">
              <span class="icon-eye-blocked watchlist-infobox__status-hidden"></span>
              <span v-html="$t('Watchlist.infobox.hidden')"></span>
          </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'watch-list-info-box',
        props: {
            selectedWatchList: {
                type: Object
            },
            rightAlign: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .watchlist-infobox {
        width: 285px;
        margin: 0 0 10px 0;
        display: flex;
        flex-direction: column;

        [class*="mobile"] & {
            text-align: center;
            width: 100%;
            padding: 0 10px;
        }

        &.right {
            text-align: right;
            margin: 0;
            white-space: nowrap;

            [class*="mobile"] & {
                padding: 0
            }
        }

        &__statuses {
            margin: 8px 0 0 0;
        }

        &__status {
            font-size: 1.5rem;
            padding: 4px;

            &-blue-theme,
            &-red-theme,
            &-black-theme,
            &-hidden {
                padding: 4px;
                font-size: 1.1rem;
                border-radius: 100%;
                margin-right: 5px;
                line-height: 2.8rem;
            }

            &-blue-theme {
                background: $cornflower;

            }

            &-red-theme {
                @include carnation(background, 0.7);
            }

            &-black-theme {
                background: $silver_chalice;
            }

            &-hidden {
                padding: 4px;
                font-size: 1.5rem;
            }

        }
    }
</style>
